import { render, staticRenderFns } from "./RealtimeTraffic.vue?vue&type=template&id=9f3b41e6&"
import script from "./RealtimeTraffic.vue?vue&type=script&lang=js&"
export * from "./RealtimeTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports